import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  inject,
  signal,
  computed,
} from '@angular/core';
import { Hardware } from '../../types/hardware';
import { Store } from '@softline/core';
import {
  HardwareManagementStore,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT,
} from '../../hardware-management.shared';
import {
  BackNavigable,
  BackNavigationService,
  showRequestErrors,
} from '@softline/application';
import { MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { Router } from '@angular/router';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputBaseComponent } from '../../components/input-base/input-base.component';
import { DynamicModule } from '@softline/dynamic';
import { BetriebssystemInputComponent } from '../../components/inputs/betriebssystem-input/betriebssystem-input.component';
import { GarantietypInputComponent } from '../../components/inputs/garantietyp-input/garantietyp-input.component';
import { HerstellerInputComponent } from '../../components/inputs/hersteller-input/hersteller-input.component';
import { ProduktInputComponent } from '../../components/inputs/produkt-input/produkt-input.component';
import { SubnetzmaskeInputComponent } from '../../components/inputs/subnetzmaske-input/subnetzmaske-input.component';
import { SupporttypInputComponent } from '../../components/inputs/supporttyp-input/supporttyp-input.component';
import { TypInputComponent } from '../../components/inputs/typ-input/typ-input.component';
import { HardwareFormDirective } from '../../directives/hardware-form.directive';
import { UserInfoService } from '@softline/auth';
import { SoftAppsUserInfo } from '@softapps/core';
import {
  SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
  UtilitiesAccountStore,
} from '@softapps/core/context';
import { KtostammStandortInputComponent } from '../../components/inputs/ktostamm-standort-input/ktostamm-standort-input.component';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { InputComponent } from '@softline/ui-core';
import { ToggleSwitchComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-create',
  imports: [
    CommonModule,
    DynamicModule,
    ReactiveFormsModule,
    BetriebssystemInputComponent,
    GarantietypInputComponent,
    HerstellerInputComponent,
    ProduktInputComponent,
    SubnetzmaskeInputComponent,
    SupporttypInputComponent,
    TypInputComponent,
    HardwareFormDirective,
    KtostammStandortInputComponent,
    DateInputComponent,
    InputComponent,
    ToggleSwitchComponent,
    TranslatePipe,
  ],
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateComponent implements OnInit, OnDestroy, BackNavigable {
  private readonly userInfo = inject<UserInfoService<SoftAppsUserInfo>>(UserInfoService);

  activeUserAccount = computed(() => {
    const accountid = this.userInfo.value()?.accountid;
    if (accountid == null) return undefined;
    return this.store.get(
      SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
      UtilitiesAccountStore.getters.entity,
      accountid
    );
  });

  constructor(
    private store: Store,
    private router: Router,
    private backNavigationService: BackNavigationService
  ) {}

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/hardware-management']);
  }

  async create(form: UntypedFormGroup): Promise<void> {
    try {
      const hardware = await this.store.dispatch(
        SOFTLINE_FEATURE_HARDWARE_MANAGEMENT,
        HardwareManagementStore.actions.create,
        { entity: form.value }
      );

      form.reset();

      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.success,
        {
          title: '',
          message: '#HARDWARE_MANAGEMENT.MESSAGES.CREATE_HARDWARE_SUCCESS',
          actions: [
            {
              title: signal('Zur Hardware'),
              type: 'link',
              onExecute: () =>
                this.router.navigate(['hardware-management', { id: hardware?.id }]),
            },
          ],
        }
      );
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }
}
